import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './EditCustomer.scss';
import { useNavigate } from 'react-router';
import { saveNewCustomerAction } from '../../../actions/newCustomerAction';
import { useJwtHeaders } from '../../../hooks/useJwtHeaders';
import { RootState } from '../../../app/store';
import { CustomerType } from '../../../slices/customerSlice/customerSlice';
import { saveUpdateAction } from '../../../actions/updateCustomerAction';

const EditCustomerPage: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const headers = useJwtHeaders();
  const customer = useSelector<RootState, CustomerType>(state => state.customer);

  const [firstName, setFirstName] = useState(customer.firstName!);
  const [lastName, setLastName] = useState(customer.lastName!);
  const [phoneNumber, setPhoneNumber] = useState(customer.phoneNumber!);
  const [email, setEmail] = useState(customer.email!);
  const [id, setId] = useState(customer.id!);

  const [disable, setDisable] = useState(true);

  useEffect(() => {
    setDisable(phoneNumber.length !== 10);
  }, [phoneNumber]);

  const handleClick = () => {
    dispatch(saveUpdateAction(navigate, firstName, lastName, phoneNumber, email, id, headers));
  };

  return (
    <div className="new-customer-form">
      <div>
        <input
          className="form-input"
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
        />
      </div>
      <div>
        <input
          className="form-input"
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />
      </div>
      <div>
        <input
          className="form-input"
          type="text"
          placeholder="Phone Number"
          value={phoneNumber}
          maxLength={10}
          onChange={e => setPhoneNumber(e.target.value.replace(/[^0-9]/, ''))}
        />
        <div className="text-muted">* Required</div>
      </div>
      <div>
        <input
          className="form-input"
          type="text"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>
      <div>
        <button
          type="button"
          disabled={disable}
          className="form-input btn btn-success"
          onClick={handleClick}>
          Update Customer
        </button>
      </div>
    </div>
  );
};

export default EditCustomerPage;
